import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const hasPermission = (admin, permission) => {
  if (!permission) return true;
  if (admin?.accountType !== "staff") return true;
  if (admin?.permissions?.includes("*")) return true;
  return admin?.permissions?.includes(permission);
};

const AdminPrivateRoute = ({ children, requiredPermission }) => {
  const { token, admin } = useSelector((state) => state.adminAuth);

  if (!token || !admin) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!hasPermission(admin, requiredPermission)) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default AdminPrivateRoute;
